import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ y: 50, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <div className="mb-6 flex items-center gap-4">
    <span className="h-px w-12 bg-[#D4AF37]" />
    <span className="text-xs font-medium uppercase tracking-[0.35em] text-[#D4AF37]">
      {children}
    </span>
  </div>
);
